import {
  ActivityIndicator,
  StyleProp,
  Text,
  TouchableOpacity,
  ViewStyle
} from "react-native";
import styled from "styled-components";
import * as React from "react";

const Button = (props: {
  loading?: boolean;
  disabled?: boolean;
  primary?: boolean;
  title: string;
  onPress: () => void;
  style?: StyleProp<ViewStyle>;
}) => (
  <Button.Container
    style={props.style}
    onPress={props.onPress}
    disabled={props.disabled || props.loading}
    primary={props.primary}
  >
    {props.loading ? (
      <ActivityIndicator />
    ) : (
      <Button.Text>{props.title}</Button.Text>
    )}
  </Button.Container>
);

Button.Text = styled(Text)`
  color: white;
  font-size: 15px;
`;

Button.Container = styled(TouchableOpacity)<{
  primary?: boolean;
}>`
  min-width: 300px;
  height: 44px;
  background-color: ${props =>
    props.primary ? "green" : props.disabled ? "gray" : "blue"};
  border-radius: 8px;
  justify-content: center;
  align-items: center;
`;

export default Button;
